module.exports = __webpack_public_path__ + "media/images/bus-184f552bda7ddea8e2afe6a3c83ed593.jpg";